const Hero = () => (
  <section
    id="top"
    className="bg-night text-ink py-20 lg:py-28 border-b border-line relative overflow-hidden radar-grid"
    data-testid="hero-section"
  >
    <div className="max-w-7xl mx-auto px-6">
      <div className="flex items-center gap-3 mb-6">
        <span className="inline-block w-2.5 h-2.5 rounded-full bg-brand animate-pulse" />
        <span className="font-mono text-xs uppercase tracking-[0.18em] text-brand" data-testid="hero-legal-name">
          DREAMS SOFT SOLUTIONS PRIVATE LIMITED
        </span>
      </div>

      <h1 className="font-display text-[clamp(40px,5.5vw,88px)] leading-[0.95] uppercase max-w-5xl mb-8 tracking-wide">
        <span className="ln"><span>National Warehouse</span></span>
        <span className="ln"><span className="text-brand">Tender Exchange.</span></span>
      </h1>

      <p className="d1-sub text-lg md:text-xl text-mute max-w-2xl mb-10 leading-relaxed" data-testid="hero-subline">
        Direct logistics procurement connecting warehouse landlords and certified
        vendors across India through transparent bidding.
      </p>

      <div className="d1-cta flex flex-wrap gap-4 items-center">
        <a
          href="#bid-enquiry"
          className="bg-brand text-night px-8 py-4 font-mono text-xs font-bold uppercase tracking-widest hover:bg-brandhover transition-colors"
          data-testid="hero-access-tenders-btn"
        >
          Access Live Tenders
        </a>
        <a
          href="#live-notices"
          className="border border-line hover:border-brand text-ink px-8 py-4 font-mono text-xs uppercase tracking-widest transition-colors"
          data-testid="hero-notice-board-btn"
        >
          Review Notice Board
        </a>
      </div>
    </div>
  </section>
);

export default Hero;
